import { initialCoRenterState } from './';
import { initialRenterState } from './';

const getRenterReferences = (arr) => arr.filter(a => a.renter_id);
const getCoRenterReferences = (arr) => arr.filter(a => a.corenter_id);

export function contractPopulate(data) {
  // data = response from server
  let renter = {...initialRenterState};
  let coRenter = {...initialCoRenterState};

  if (data.renter) {
    Object.keys(renter).forEach(k => {
      data.renter[k]
        ? renter[k] = data.renter[k]
        : null
    })

    const renterRefs = getRenterReferences(data.references);
    renter.references = renterRefs;
  }

  if (data.corenter) {
    Object.keys(coRenter).forEach(k => {
      data.corenter[k]
        ? coRenter[k] = data.corenter[k]
        : null
    })

    const coRenterRefs = getCoRenterReferences(data.references);

    coRenter.references = coRenterRefs;
  }

  const termRelatedKeys = [
    'additional_purchase_reserve',
    'cash_total',
    'cost_reduction_after_tax',
    'final_cost_of_unit',
    'minimum_purchase_reserve',
    'monthly_pretax',
    'monthly_tax',
    'tax_on_deposit',
    'total_monthly_payment',
    'total_purchase_reserve',
    'term',
    'tax_rate',
    'early_po_payoff',
    'full_term_payoff',
    'total_hvac_system_cost',
  ];

  let term = null;

  termRelatedKeys.forEach(t => {
    if (data[t]) {
      term
        ? term[t] = data[t]
        : term = { [t]: data[t]}
    }
  });

  const contractImageRelatedKeys = [
    'voided_check_image',
    'drivers_license_image',
    'proof_of_residence_image',
    'proof_of_income_image'
  ];

  let contractRelatedImages = {};

  contractImageRelatedKeys.forEach(c => {
    if (data[c]) {
      contractRelatedImages[c] = data[c];
    }
  });

  let systems = [];
  if (data.status !== '0') {
    data.hvac_systems.forEach(sys => systems.push(sys));
  } else {
    // check for old data, contracts that have been
    // made without contract_builder systems
    if (data.contract_builder_systems.length) {
      data.contract_builder_systems.forEach(sys => systems.push(sys));
    } else {
      data.hvac_systems.forEach(sys => systems.push(sys));
    }
  }

  const taxZip = () => {
    if (data.tax_zip) {
      return data.tax_zip;
    };

    if (data.zip) {
      return data.zip;
    };

    return 'n/a';
  }

  const taxState = () => {
    if (data.tax_state) {
      return data.tax_state;
    }

    if (data.state) {
      return data.state;
    }

    return 'n/a';
  }

  return {
    additional_cost: data.additional_cost !== null & data.additional_cost !== undefined ? data.additional_cost : '',
    additional_cost_note: data.additional_cost_note !== null & data.additional_cost_note !== undefined ? data.additional_cost_note : '',
    approval_note: data.approval_note ? data.approval_note : null,
    contractImages: contractRelatedImages,
    contract_pdf_filename: data.contract_pdf_filename ? data.contract_pdf_filename : null,
    coRenter: data.corenter ? coRenter : null,
    county: data.county ? data.county: '',
    dealer: data.dealer ? data.dealer : null,
    down_payment: data.additional_purchase_reserve ? data.additional_purchase_reserve : 0,
    id: data.id,
    payment: data.down_payment,
    remote_code: data.remote_code ? data.remote_code : null,
    renter,
    reviewed_by: data.reviewed_by ? data.reviewed_by : null,
    salesperson: data.salesperson ? data.salesperson : null,
    status: data.status,
    systems,
    tax_state: taxState(),
    taxZip: taxZip(),
    term,
  };
}

